/**
 * THIS IS GENERATED CODE!
 * PLEASE DO NOT MODIFY - ALL YOUR WORK WOULD BE LOST!
 */
export const typescriptDeclarationFixConstant = 1;
export enum UiFieldMessageVisibilityMode {
	ON_FOCUS, ON_HOVER_OR_FOCUS, ALWAYS_VISIBLE
}